<template>
    <div class="wrap" style="margin:0 -12px;">
        <div class="container">
            <div class="row">
                <div class="col px-0">
                    <img src="/images/Group13415.png" class="img-fluid">
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-1"></div>
                <div class="col px-0">
                    <div style="padding-right:7.5px;">
                        <img src="/images/Group13418.png" class="img-fluid">
                    </div>
                </div>
                <div class="col-1"></div>
            </div>
            <br>
            <div class="row">
                <div class="col">
                    <div style="padding:0 10px;">
                        <div>
                            <small> お問い合わせ先メールアドレス </small>
                        </div>
                        <input type="text" class="luna-form-control" v-model="customer_mail" placeholder="入力する"
                            @focus="is_mail_format = false" />
                        <p class="error-text" id="error-text_my_like" v-if="is_mail_format"><i
                                class="bi bi-x-circle-fill"></i>正しいメールアドレスではありません
                        </p>
                        <br>
                        <div>
                            <small> お問い合わせ先メールアドレス（確認用） </small>
                        </div>
                        <input type="text" class="luna-form-control" v-model="customer_mail_conf" placeholder="入力する"
                            @focus="isMailFormat(), is_conf = true" />
                        <p class="error-text" id="error-text_my_like"
                            v-if="is_conf && (customer_mail != customer_mail_conf)"><i
                                class="bi bi-x-circle-fill"></i>メールアドレスが一致しません
                        </p>
                    </div>
                </div>
            </div>
            <br />
            <div class="row justify-content-center">
                <div class="col-9">
                    <br />
                    <div class="d-grid gap-2">
                        <button type="button" class="btn btn-luna disabled" style="padding: 12px 0" v-if="is_load">
                            <div class="spinner-border" style="width: 1rem; height: 1rem;" role="status" v-if="is_load">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            次へ
                        </button>
                        <button type="button" class="btn btn-luna" style="padding: 12px 0" @click="setEvent()" id="on-btn"
                            v-else-if="isEventNext()">
                            次へ
                        </button>
                        <button type="button" class="btn btn-luna-d disabled" style="padding: 12px 0" id="non-btn" v-else>
                            次へ
                        </button>
                    </div>
                    <p class="error-text text-center" id="error-text_my_like" v-if="!isEventNext()">
                        <i class="bi bi-x-circle-fill"></i>未入力の項目があります。
                    </p>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col">
                    <a href="/event/entry/question2" style="font-size:12px;">
                        <svg style="height:12px;width:12px;fill:#6B4EFF;margin-top:-2px">
                            <use xlink:href="/images/<.svg#page_left"></use>
                        </svg>&nbsp;前のフォームに戻る</a>
                </div>
            </div>
            <br>
            <br>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            customer_mail: "",
            customer_mail_conf: "",
            is_load: false,
            event_info: {},
            is_mail_format: false,
            is_conf: false,
        };
    },
    methods: {
        isMailFormat() {

            //メールアドレスとして判定される文字列と記号の組み合わせを定数化
            const reg = new RegExp(/^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/);
            //指定した組み合わせになっていなかった場合判定を返す。

            if (!reg.test(this.customer_mail)) {
                this.is_mail_format = true
            }
            else {
                this.is_mail_format = false
            }
        },
        isEventNext() {

            //メールアドレスとして判定される文字列と記号の組み合わせを定数化
            const reg = new RegExp(/^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/);
            //指定した組み合わせになっていなかった場合判定を返す。

            if (!reg.test(this.customer_mail)) {
                return false
            }

            if (this.customer_mail.length == 0) {
                return false
            }
            else if (this.customer_mail != this.customer_mail_conf) {
                return false
            }

            return true
        },
        initEvent() {
            if (localStorage.getItem('luna_event_entry') !== null) {
                let serializedArray = localStorage.getItem('luna_event_entry');
                let event = JSON.parse(serializedArray);

                this.event_info = event
                this.customer_mail = (event['customer_mail'] == null) ? '' : event['customer_mail']
            }
        },
        rmEventInfo() {
            if (localStorage.getItem('luna_event_entry') !== null) {
                localStorage.removeItem('luna_event_entry')
            }
        },
        setEvent() {

            let event = {
                'thumbnail': this.event_info['thumbnail'],
                'event_at': this.event_info['event_at'],
                'event_at_open_1': this.event_info['event_at_open_1'],
                'event_at_from_1': this.event_info['event_at_from_1'],
                'event_at_to_1': this.event_info['event_at_to_1'],
                'event_at_open_2': this.event_info['event_at_open_2'],
                'event_at_from_2': this.event_info['event_at_from_2'],
                'event_at_to_2': this.event_info['event_at_to_2'],
                'event_at_open_3': this.event_info['event_at_open_3'],
                'event_at_from_3': this.event_info['event_at_from_3'],
                'event_at_to_3': this.event_info['event_at_to_3'],
                'event_type': this.event_info['event_type'],
                'event_type_val': this.event_info['event_type_val'],
                'catch_copy': this.event_info['catch_copy'],
                'event_details': this.event_info['event_details'],
                'event_feature': this.event_info['event_feature'],
                'event_recommend': this.event_info['event_recommend'],
                'event_summary': this.event_info['event_summary'],
                'img_url': this.event_info['img_url'],

                'amount1': this.event_info['amount1'],
                'amount2': this.event_info['amount2'],
                'amount3': this.event_info['amount3'],
                'amount4': this.event_info['amount4'],
                'amount5': this.event_info['amount5'],
                'amount6': this.event_info['amount6'],
                'amount7': this.event_info['amount7'],
                'amount8': this.event_info['amount8'],
                'event_notes': this.event_info['event_notes'],
                'address': this.event_info['address'],
                'area': this.event_info['area'],
                'area_value': this.event_info['area_value'],

                'is_player': this.event_info['is_player'],
                'players': this.event_info['players'],
                'player_type': this.event_info['player_type'],

                'member_count': this.event_info['member_count'],
                'organizer': this.event_info['organizer'],
                'venue_name': this.event_info['venue_name'],

                'customer_mail': this.customer_mail
            }

            const serializedArray2 = JSON.stringify(event)
            localStorage.setItem('luna_event_entry', serializedArray2)

            window.location.href = "/event/entry/question4"
        },
        async isAuth() {
            await axios.get("/api/auth/user/get")
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.isAuth()
                            this.initEvent()
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    })
            }
            else {
                this.isAuth()
                this.initEvent()
            }
        }
        else {
            this.isAuth()
            this.initEvent()
        }
    },
};
</script>

<style scoped>
small {
    color: #5538EE;
}

.select_sex {
    border: 0px;
}

.vs__dropdown-toggle {
    border-top: 0px;
    border-right: 0px;
    border-left: 0px;
    border-bottom: 1px solid #ced4da;
    border-radius: 0;
}

.vs__selected-options {
    color: #cdcfd0;
}

.sub_windows {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 111;
}

.croppa-container {
    background-color: #fff;
    border-radius: 8px;
}

.luna-search-bar {
    padding: 8px 12px 10px 12px;
    background-color: #fff;
    border-radius: 5px;
    color: #333333;
    border: 1px solid #E6E6E6;
}


.luna-search-select-bar {
    padding: 8px 12px 10px 12px;
    background-color: #f0f0ff;
    border-radius: 5px;
    color: #000000;
}
</style>
